const PageLoader = () => {
  return 	<div id="loader-wrapper">
    <div id="loader"><div className="loader-inner"></div></div>
  </div>

}
export default PageLoader;